<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading" class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
<div class="card">
	<div class="card-header">
		<h5 class="card-title mb-0">
			{{pagetitle}}
		</h5>
	</div>
	<div class="card-body">
		<div class="row mb-lg">
			<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
				<iframe class="pdf-container" *ngIf="fileURL" [src]="fileURL" type="application/pdf"></iframe>
			</div>
		</div>
	</div>
</div>